import type { ReactNode } from "react";

interface ScenePanelProps {
  image: string;
  alt: string;
  side: "left" | "right";
  children: ReactNode;
}

const ScenePanel = ({ image, alt, side, children }: ScenePanelProps) => (
  <section className={`landing-scene-panel is-${side}`}>
    <div className="landing-scene-media">
      <img src={image} alt={alt} loading="lazy" />
      <span className="landing-scene-fire" aria-hidden="true" />
    </div>
    <div className="landing-scene-content">{children}</div>
  </section>
);

export default ScenePanel;
